export class BassPatternStrategy {
  generate(ctx, chord, oct, baseDegree, rand, bpb, genre) {
    if (genre === 'jazz') return this._genJazzBass(ctx, chord, oct, baseDegree, rand, bpb);
    if (genre === 'breakcore') return this._genBreakcoreBass(ctx, chord, oct, baseDegree, rand, bpb);
    if (genre === 'ambient') return this._genAmbientBass(ctx, chord, oct, baseDegree, rand, bpb);
    if (genre === 'lofi') return this._genLofiBass(ctx, chord, oct, baseDegree, rand, bpb);
    return this._genBass(ctx, chord, oct, baseDegree, rand, bpb);
  }

  _genBass(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    const bassOct = oct - 1;
    const root = chord[0];
    const fifth = chord.length > 2 ? chord[2] : root + 7;
    pattern.push({ beat: 0, note: ctx.noteFromSemitone(root, bassOct), duration: 0.8 });
    const midBeat = Math.floor(bpb / 2);
    if (rand() < 0.55 && bpb >= 3) {
      const passing = chord.length > 1 ? chord[1] : root + 4;
      pattern.push({ beat: midBeat - 0.5, note: ctx.noteFromSemitone(passing, bassOct), duration: 0.35 });
    }
    if (bpb >= 3) {
      const beat3note = rand() < 0.6 ? fifth : root;
      pattern.push({ beat: midBeat, note: ctx.noteFromSemitone(beat3note, bassOct), duration: 0.7 });
    }
    if (rand() < 0.45 && bpb >= 4 && ctx.chordProgression?.length) {
      const nextChordIdx = (ctx.chordIndex + 1) % ctx.chordProgression.length;
      const nextChord = ctx.chordProgression[nextChordIdx];
      if (nextChord?.length) {
        const nextRoot = nextChord[0];
        const approach = nextRoot > 0 ? nextRoot - 1 : nextRoot + 11;
        pattern.push({ beat: bpb - 0.5, note: ctx.noteFromSemitone(approach, bassOct), duration: 0.3 });
      }
    }
    return pattern;
  }

  _genJazzBass(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    const bassOct = oct - 1;
    const chordDegrees = ctx.chordToScaleDegrees(chord);
    let currentDeg = chordDegrees.length > 0 ? chordDegrees[0] : 0;
    for (let beat = 0; beat < bpb; beat++) {
      const isStrong = (beat === 0 || beat === Math.floor(bpb / 2));
      if (isStrong && chordDegrees.length > 0) {
        currentDeg = chordDegrees[Math.floor(rand() * chordDegrees.length)];
      } else {
        const step = rand() < 0.6 ? (rand() < 0.5 ? 1 : -1) : (rand() < 0.5 ? 2 : -2);
        currentDeg += step;
        currentDeg = Math.max(-2, Math.min(currentDeg, ctx.scale.length * 2));
      }
      pattern.push({ beat, note: ctx.noteFromDegree(currentDeg, bassOct), duration: 0.35 + rand() * 0.15 });
    }
    return pattern;
  }

  _genBreakcoreBass(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    const bassOct = oct - 1;
    const root = chord[0];
    const fifth = chord.length > 2 ? chord[2] : root + 7;
    const flat7 = root + 10;
    for (let b = 0; b < bpb; b += 0.25) {
      if (rand() < 0.35) {
        const r = rand();
        const note = r < 0.5 ? root : r < 0.8 ? fifth : flat7;
        pattern.push({ beat: b, note: ctx.noteFromSemitone(note, bassOct), duration: 0.05 + rand() * 0.15 });
      }
    }
    if (!pattern.some(p => p.beat === 0)) {
      pattern.unshift({ beat: 0, note: ctx.noteFromSemitone(root, bassOct), duration: 0.12 });
    }
    return pattern;
  }

  _genAmbientBass(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    const bassOct = oct - 1;
    const root = chord[0];
    pattern.push({ beat: 0, note: ctx.noteFromSemitone(root, bassOct), duration: bpb * ctx.beatDuration * 0.9 });
    if (rand() < 0.3 && chord.length > 2) {
      pattern.push({ beat: 0.05, note: ctx.noteFromSemitone(chord[2], bassOct), duration: bpb * ctx.beatDuration * 0.7 });
    }
    return pattern;
  }

  _genLofiBass(ctx, chord, oct, baseDegree, rand, bpb = 4) {
    const pattern = [];
    const bassOct = oct - 1;
    const root = chord[0];
    const fifth = chord.length > 2 ? chord[2] : root + 7;
    pattern.push({ beat: 0, note: ctx.noteFromSemitone(root, bassOct), duration: 0.6 + rand() * 0.3 });
    if (bpb >= 3 && rand() < 0.7) {
      const midBeat = Math.floor(bpb / 2) + (rand() < 0.5 ? 0.5 : 0);
      pattern.push({ beat: midBeat, note: ctx.noteFromSemitone(fifth, bassOct), duration: 0.5 + rand() * 0.2 });
    }
    return pattern;
  }
}
